import React, { useState } from 'react';
import { Trash2, Plus, Minus, CreditCard } from 'lucide-react';
import { useCart } from '../../context/CartContext';

const CartView = () => {
  const { cart, removeFromCart, updateQty, cartTotal, placeOrder } = useCart();
  const [orderPlaced, setOrderPlaced] = useState(null);

  const handleCheckout = () => {
    // Placeholder — will integrate payment gateway
    const order = placeOrder();
    if (order) setOrderPlaced(order);
  };

  if (orderPlaced) {
    return (
      <div className="flex flex-col items-center justify-center py-24 space-y-4">
        <div className="w-16 h-16 rounded-full flex items-center justify-center" style={{ background: 'rgba(34,197,94,0.1)' }}>
          <CreditCard size={28} style={{ color: '#22c55e' }} />
        </div>
        <h2 className="text-2xl font-bold text-foreground-primary">Order Placed</h2>
        <p className="text-foreground-secondary">Order ID: <span className="font-mono text-foreground-primary">{orderPlaced.id}</span></p>
        <p className="text-sm text-foreground-muted">Payment gateway integration coming soon. Your order has been recorded.</p>
        <button
          onClick={() => setOrderPlaced(null)}
          className="px-6 py-2 rounded-lg text-sm font-semibold transition-smooth"
          style={{ border: '1px solid rgba(249,115,22,0.4)', color: '#F97316' }}
        >
          Continue Shopping
        </button>
      </div>
    );
  }

  if (cart.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-24 space-y-3">
        <p className="text-foreground-muted text-lg">Your cart is empty</p>
        <p className="text-sm text-foreground-secondary">Browse the marketplace and add items to get started.</p>
      </div>
    );
  }

  return (
    <div>
      <h2 className="text-2xl font-bold text-foreground-primary mb-6">Cart</h2>
      <div className="space-y-0">
        {cart.map((item) => (
          <div key={item.id} className="flex items-center gap-4 py-4 border-b border-subtle last:border-b-0">
            <div
              className="w-12 h-12 rounded-lg flex-shrink-0 flex items-center justify-center"
              style={{ background: 'rgba(249,115,22,0.06)' }}
            >
              <img src={item.photo} alt={item.name} className="w-8 h-8 object-contain" onError={(e) => { e.target.style.display = 'none'; }} />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-semibold text-foreground-primary truncate">{item.name}</h3>
              <p className="text-xs text-foreground-muted">{item.category}</p>
            </div>
            <div className="flex items-center gap-2">
              <button onClick={() => updateQty(item.id, item.qty - 1)} className="p-1 rounded hover:bg-subtle transition-smooth text-foreground-muted">
                <Minus size={14} />
              </button>
              <span className="text-sm font-medium text-foreground-primary w-6 text-center">{item.qty}</span>
              <button onClick={() => updateQty(item.id, item.qty + 1)} className="p-1 rounded hover:bg-subtle transition-smooth text-foreground-muted">
                <Plus size={14} />
              </button>
            </div>
            <span className="text-sm font-semibold w-24 text-right" style={{ color: item.price === 0 ? '#22c55e' : '#F97316' }}>
              {item.price === 0 ? 'Free' : `${item.currency}${(item.price * item.qty).toLocaleString()}`}
            </span>
            <button onClick={() => removeFromCart(item.id)} className="p-1.5 rounded hover:bg-subtle transition-smooth text-foreground-muted hover:text-red-400">
              <Trash2 size={14} />
            </button>
          </div>
        ))}
      </div>

      <div className="mt-8 glass-frosted rounded-2xl p-6 glow-subtle">
        <div className="flex items-center justify-between mb-4">
          <span className="text-foreground-secondary font-medium">Total</span>
          <span className="text-2xl font-bold" style={{ color: '#F97316' }}>
            {cartTotal === 0 ? 'Free' : `₹${cartTotal.toLocaleString()}`}
          </span>
        </div>
        <button
          onClick={handleCheckout}
          className="w-full py-3 rounded-lg font-semibold transition-smooth inline-flex items-center justify-center gap-2"
          style={{ background: '#F97316', color: '#0B0E13' }}
          onMouseEnter={(e) => { e.currentTarget.style.boxShadow = '0 0 30px rgba(249,115,22,0.5)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.boxShadow = 'none'; }}
        >
          <CreditCard size={18} />
          Proceed to Checkout
        </button>
        <p className="text-[11px] text-foreground-muted text-center mt-3">Payment gateway integration coming soon.</p>
      </div>
    </div>
  );
};

export default CartView;
